module.exports = __webpack_public_path__ + "static/media/search.0171ffb0.svg";